<template>
  <div>
    <!-- Trigger Button -->
    <b-button class="search-btn" size="sm" variant="warning" @click="showFilterClient">
      Shipment Track
    </b-button>

    <!-- Modal -->
    <b-modal id="FilterClient-modal" ref="filterClientModal" title="Filter Shipment Tracking" size="xl" no-close-on-esc
      no-close-on-backdrop hide-footer>
      <b-row>
        <b-col cols="12">
          <TimelineTrackDash :showList="false" />
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button variant="danger" @click="hideFilterClient" style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">Close</b-button>
          <b-button @click="goShipmentTrack"  size="sm" variant="success"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">Shipment Track</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import TimelineTrackDash from "../tracking/timelineTrackDash.vue";
import CustomLoader from "../common/customLoader.vue";

export default {
  components: {
    TimelineTrackDash,
    CustomLoader,
  },
  methods: {
    showFilterClient() {
      this.$refs.filterClientModal.show();
    },
    hideFilterClient() {
      this.$refs.filterClientModal.hide();
    },
    goShipmentTrack() {
      this.$router.push({
        path: "/ctt/subs-timeline-track",
      });
    },
  },
};
</script>

<style scoped>
.search-btn {
  font-size: 0.675rem;
  margin-left: 5px;
  margin-bottom: 4px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, opacity 0.5s ease;
}

.card:hover {
  transform: scale(1.05);
}

.card-header {
  background-color: #3498db;
  color: #ffffff;
  padding: 10px;
  font-weight: bold;
}

.card-body {
  padding: 15px;
}

.client-details {
  margin-top: 10px;
  color: #555;
}

a {
  color: #3498db;
  font-weight: bold;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Fade-in animation (optional if used with transition-group) */
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.5s;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// ShipmentTrackCard.vue?4992388d